import BuyerConnect from './BuyerConnect';
export default BuyerConnect;